module.exports = __webpack_public_path__ + "static/media/race-course.ff5b043b.jpg";